import apiClient from './api';

const hostelService = {
  // Admin endpoints - get all records
  getAdmissions: async (params) => {
    return apiClient.get('/hostel/admin/admissions', { params });
  },

  getAdmission: async (id) => {
    return apiClient.get(`/hostel/admissions/${id}`);
  },

  createAdmission: async (data) => {
    return apiClient.post('/hostel/admissions', data);
  },

  updateAdmission: async (id, data) => {
    return apiClient.put(`/hostel/admissions/${id}`, data);
  },

  getRooms: async (params) => {
    return apiClient.get('/hostel/admin/rooms', { params });
  },

  getRoom: async (id) => {
    return apiClient.get(`/hostel/rooms/${id}`);
  },

  allocateRoom: async (roomId, data) => {
    return apiClient.put(`/hostel/rooms/${roomId}/allocate`, data);
  },

  getLeaves: async (params) => {
    return apiClient.get('/hostel/admin/leaves', { params });
  },

  createLeave: async (data) => {
    return apiClient.post('/hostel/leaves', data);
  },

  approveLeave: async (leaveId) => {
    return apiClient.put(`/hostel/leaves/${leaveId}/approve`);
  },

  updateLeaveStatus: async (leaveId, data) => {
    return apiClient.put(`/hostel/admin/leaves/${leaveId}/status`, data);
  },

  // Hostel Locations (for search/booking feature)
  getLocations: async (params) => {
    return apiClient.get('/hostel/admin/locations', { params });
  },

  createLocation: async (data) => {
    return apiClient.post('/hostel/admin/locations', data);
  },

  updateLocation: async (id, data) => {
    return apiClient.put(`/hostel/admin/locations/${id}`, data);
  },

  deleteLocation: async (id) => {
    return apiClient.delete(`/hostel/admin/locations/${id}`);
  },

  // Image upload
  uploadHostelImage: async (file) => {
    const formData = new FormData();
    formData.append('image', file);
    return apiClient.post('/hostel/upload-image', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },

  // Amenities management
  getAmenities: async (hostelId) => {
    return apiClient.get(`/hostel/admin/locations/${hostelId}/amenities`);
  },

  updateAmenities: async (hostelId, amenities) => {
    return apiClient.put(`/hostel/admin/locations/${hostelId}/amenities`, { amenities });
  },

  addAmenity: async (hostelId, amenity) => {
    return apiClient.post(`/hostel/admin/locations/${hostelId}/amenities/add`, { amenity });
  },

  removeAmenity: async (hostelId, amenity) => {
    return apiClient.post(`/hostel/admin/locations/${hostelId}/amenities/remove`, { amenity });
  },

  // Booking Requests
  getBookingRequests: async (params) => {
    return apiClient.get('/hostel/admin/booking-requests', { params });
  },

  updateBookingStatus: async (id, data) => {
    return apiClient.put(`/hostel/booking-requests/${id}/status`, data);
  },

  // Room management
  getRooms: async (hostelId, params) => {
    if (typeof hostelId === 'object') {
      params = hostelId;
      return apiClient.get('/hostel/admin/rooms', { params });
    }
    return apiClient.get(`/hostel/admin/locations/${hostelId}/rooms`, { params });
  },

  addRoom: async (hostelId, data) => {
    return apiClient.post(`/hostel/admin/locations/${hostelId}/rooms`, data);
  },

  deleteRoom: async (roomId) => {
    return apiClient.delete(`/hostel/admin/rooms/${roomId}`);
  },

  updateRoom: async (roomId, data) => {
    return apiClient.put(`/hostel/admin/rooms/${roomId}`, data);
  },

  confirmAdmission: async (admissionId, data) => {
    return apiClient.post(`/hostel/admin/admission/${admissionId}/confirm`, data);
  },

  verifyCashPayment: async (admissionId, data) => {
    return apiClient.post(`/hostel/admin/admission/${admissionId}/verify-cash-payment`, data);
  },
};

export default hostelService;
